<template>

      <v-alert
    v-if="dataUser.IndAutenticado"
    border="left"
    dense
    color="success-400"
    class="primary--text"
  >
    <v-icon color="primary" small>mdi-asterisk</v-icon>
    {{ msg }}
  </v-alert>
  
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    msg: String,
  },
  computed: {
    ...mapState(["dataUser"]),
  },
};
</script>

<style scoped>
.menu {
  height: 100%;
  position: sticky;
  top: 100px;
  z-index:5
}
</style>
